import React from "react";
import { Link } from "react-router-dom";
import { PageContainer } from "../components/PageContainer";
import { Seo } from "../components/Seo";
import {
  pageHeadingClasses,
  pageLeadClasses,
  sectionCardClasses,
  subtleEyebrowClasses,
} from "../styles/pageClasses";

export default function Terms() {
  return (
    <PageContainer maxWidth="4xl">
      <Seo
        title="Terms of Use"
        description="Read the terms governing access to and use of the Summer Jobs in Greece website."
        path="/terms"
      />

      <div className={`${sectionCardClasses} space-y-6`}>
        <Link to="/blog" className="inline-flex text-sm font-medium text-[#a2572b] underline-offset-4 hover:underline">
          Back to Blog
        </Link>
        <span className={subtleEyebrowClasses}>Terms</span>
        <h1 className={pageHeadingClasses}>Terms of Use</h1>
        <p className={pageLeadClasses}>
          These Terms of Use govern access to and use of the Summer Jobs in Greece website.
        </p>

        <div className="space-y-4 text-sm leading-7 text-[#34566a]">
          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Use of the website</h2>
            <p>You may browse and use this website only for lawful purposes. You must not attempt to interfere with the website, access restricted areas without permission, or misuse forms, admin tools, or uploaded content.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Content</h2>
            <p>The site may contain editorial content, destination information, seasonal job information, and external links. We aim to keep content accurate and up to date, but we do not guarantee that all information is complete, current, or suitable for every user.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">No employment guarantee</h2>
            <p>Any job-related information on the site is provided for general information only. Summer Jobs in Greece does not guarantee job availability, hiring outcomes, pay, accommodation, or any arrangement made between users and third parties.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">External links</h2>
            <p>The website may link to third-party websites or services. We are not responsible for the content, availability, or privacy practices of external sites.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Intellectual property</h2>
            <p>Unless otherwise stated, the website content, layout, branding, and original materials on this site are owned by or licensed to Summer Jobs in Greece. You may not copy, republish, or commercially reuse material without permission, except where allowed by law.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Admin accounts</h2>
            <p>Admin access, where provided, is restricted. Any admin credentials must be kept secure, and activity performed using those credentials is the responsibility of the authorized holder.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Availability and changes</h2>
            <p>We may update, suspend, restrict, or remove any part of the website at any time without notice. We may also revise these Terms from time to time by publishing an updated version on this page.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Liability</h2>
            <p>To the fullest extent permitted by law, Summer Jobs in Greece is not liable for indirect or consequential loss arising from use of the website, reliance on its content, or interactions with third parties discovered through the website.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Contact</h2>
            <p>If you have questions about these Terms, contact <a className="underline" href="mailto:contact@summerjobsingreeceguide.com">contact@summerjobsingreeceguide.com</a>.</p>
          </section>
        </div>
      </div>
    </PageContainer>
  );
}
